module.exports = __webpack_public_path__ + "static/img/about_icon3.6d0f65f1.png";